export function getCheckoutEligibilitySource({ attendanceData, calendarData }) {
  if (calendarData?.dailyHours?.length) {
    return calendarData;
  }

  return attendanceData;
}
